import React from 'react';
import './Home.scss';

const Home = () => (
  <div className="home flex-col">
    <h1 data-testid="home-heading">Welcome to our page!</h1>
    <p>
      Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum ipsa
      praesentium inventore earum! Eveniet architecto exercitationem, qui eos,
      perferendis possimus unde, tenetur maxime ipsam ex doloribus alias dicta
      tempore fuga? Dolore, fugit fuga. Consequuntur cum delectus fugiat quaerat
      error porro culpa repudiandae nostrum aspernatur provident! Expedita quas,
      aut repellendus totam quo quam nam et sint officia reiciendis inventore
      quis dolorem qui, dignissimos modi sequi illo, sunt deleniti eligendi
      aliquid mollitia nesciunt? Voluptatibus dolores, laborum reprehenderit
      aliquid voluptas libero ipsa, debitis eum tenetur accusantium iusto ex
      numquam mollitia reiciendis aut eius delectus fuga molestias at sed
      adipisci hic optio dolore beatae. Modi sed illum numquam! Nesciunt aliquam
      natus voluptates animi facere maiores a impedit dolore corrupti
      recusandae, dolorem non nisi, placeat quo rem harum. Excepturi perferendis
      tenetur architecto est commodi assumenda ratione adipisci quis? Cumque,
      quasi! Ipsum nulla neque, non harum nesciunt saepe eveniet odit sint quod
      eum atque rerum optio omnis sunt laudantium quibusdam corporis quaerat ea
      odio perspiciatis veritatis minus voluptates? Minus rerum reiciendis quos
      in libero sapiente cupiditate porro labore unde dolorem vel voluptate, id
      nesciunt consequuntur numquam voluptatibus impedit nam. Alias animi
      officia aspernatur? Ab rem ut fugit cum quaerat debitis consectetur itaque
      consequuntur! Excepturi, quibusdam laboriosam.
    </p>

    <p>
      Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum ipsa
      praesentium inventore earum! Eveniet architecto exercitationem, qui eos,
      perferendis possimus unde, tenetur maxime ipsam ex doloribus alias dicta
      tempore fuga? Dolore, fugit fuga. Consequuntur cum delectus fugiat quaerat
      error porro culpa repudiandae nostrum aspernatur provident! Expedita quas,
      aut repellendus totam quo quam nam et sint officia reiciendis inventore
      quis dolorem qui, dignissimos modi sequi illo, sunt deleniti eligendi
      aliquid mollitia nesciunt? Voluptatibus dolores, laborum reprehenderit
      aliquid voluptas libero ipsa, debitis eum tenetur accusantium iusto ex
      numquam mollitia reiciendis aut eius delectus fuga molestias at sed
      adipisci hic optio dolore beatae. Modi sed illum numquam! Nesciunt aliquam
      natus voluptates animi facere maiores a impedit dolore corrupti
      recusandae, dolorem non nisi, placeat quo rem harum. Excepturi perferendis
      tenetur architecto est commodi assumenda ratione adipisci quis? Cumque,
      quasi! Ipsum nulla neque, non harum nesciunt saepe eveniet odit sint quod
      eum atque rerum optio omnis sunt laudantium quibusdam corporis quaerat ea
      odio perspiciatis veritatis minus voluptates? Minus rerum reiciendis quos
      in libero sapiente cupiditate porro labore unde dolorem vel voluptate, id
      nesciunt consequuntur numquam voluptatibus impedit nam. Alias animi
      officia aspernatur? Ab rem ut fugit cum quaerat debitis consectetur itaque
      consequuntur! Excepturi, quibusdam laboriosam.
    </p>
  </div>
);

export default Home;
